import axios from "axios";

const instance = axios.create();
const _HANDLER = {};

instance.interceptors.request.use(
  (request) => {
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

_HANDLER.processGet = function (url, options) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, options)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

_HANDLER.processPost = function (url, body, params) {
  return new Promise((resolve, reject) => {
    instance
      .post(url, body, params)
      .then((response) => {
        resolve(response);

      })
      .catch((error) => {
        reject(error);
      })
  });
};


_HANDLER.processDelete = function (url, body) {
  return new Promise((resolve, reject) => {
    instance({
      method: 'delete',
      url: url,
      data: body
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      })
  });
};

_HANDLER.processPut = function (url, options) {
  return new Promise((resolve, reject) => {
    instance
      .put(url, options)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default _HANDLER;